import { ClusterFeature } from 'supercluster'
import IGeoJSONParser from '../IGeoJSONParser'
import { Cluster, GeoJSONPoint } from '../types'
import ClusterCarSVG from '../svgs/ClusterCarSVG'

export default class GoogleMapsDefaultParser implements IGeoJSONParser<google.maps.Marker> {
    private isGoogleMapsMarker(m: google.maps.Marker | Record<string, unknown>): m is google.maps.Marker {
        return (m as google.maps.Marker).getPosition !== undefined
    }

    public to(value: google.maps.Marker): GeoJSONPoint {
        const position = value?.getPosition()
        if (!position) throw "Marker is null or undefined, can't  convert to Point"

        return {
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [position.lng(), position.lat()]
            },
            properties: { origin: { value } }
        }
    }

    public from(point: GeoJSONPoint): google.maps.Marker {
        if (point?.properties?.origin && this.isGoogleMapsMarker(point?.properties?.origin)) {
            return point?.properties?.origin
        }

        return new google.maps.Marker({
            position: { lat: point.geometry.coordinates[1], lng: point.geometry.coordinates[0] }
        })
    }

    public clusterFeatureToCluster(
        clusterFeature: ClusterFeature<{ origin: { value: google.maps.MarkerOptions & {setup: Function | null, callback: Function | null} } }>,
        clusterExpansionZoom: number
    ): Cluster<google.maps.Marker> {
        const marker = new google.maps.Marker({
            position: { lat: clusterFeature.geometry.coordinates[1], lng: clusterFeature.geometry.coordinates[0] },
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + clusterFeature.properties.point_count,
            icon: clusterFeature.properties.cluster_id
                ? this.getSvg(clusterFeature.properties.point_count)
                : clusterFeature.properties?.origin.value.icon,
            infoWindowRef: clusterFeature.properties?.origin?.value?.infoWindowRef || null,     
        })

        return {
            clusterId: clusterFeature.properties.cluster_id,
            pointsCount: clusterFeature.properties.point_count,
            marker,
            clusterExpansionZoom
        }
    }

    private getSvg(pointsCount): google.maps.Icon {
        const svg = ClusterCarSVG(pointsCount)
        return { url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg) }
    }
}
